import {
  HowDoYouGetPaidResult,
  HowDoYouGetPaidResultTypenames,
  HowDoYouGetPaidSuccess,
} from '@varo/graphql-schema-types';
import HowDoYouGetPaidQuery from 'services/graphql/queries/onboarding/HowDoYouGetPaid.query';
import { useQuery } from 'urql';

const useHowDoYouGetPaid = () => {
  const [{ data, fetching, error }] = useQuery<{
    howDoYouGetPaid: HowDoYouGetPaidResult;
  }>({
    query: HowDoYouGetPaidQuery,
    requestPolicy: 'network-only',
  });

  const successData =
    data?.howDoYouGetPaid?.__typename ===
    HowDoYouGetPaidResultTypenames.HowDoYouGetPaidSuccess
      ? (data.howDoYouGetPaid as HowDoYouGetPaidSuccess)
      : null;

  const hasError =
    data?.howDoYouGetPaid?.__typename ===
      HowDoYouGetPaidResultTypenames.HowDoYouGetPaidError || !!error;

  return {
    successData,
    isLoading: fetching,
    hasError,
  };
};

export default useHowDoYouGetPaid;
